import { LoadingPanel } from "@/components/LoadingPanel";
import { useAuth } from "@/hooks/useAuth";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Magic-link return URL. Supabase JS auto-detects the session in the URL hash
 * (because we set `detectSessionInUrl: true`), so we just wait for the auth
 * provider to flip user from null to a session, then redirect.
 *
 * If no session lands within a short window we send the user back to /login.
 */
export function AuthCallback() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (user) {
      navigate("/", { replace: true });
      return;
    }
    const timer = setTimeout(() => {
      navigate("/login?error=expired", { replace: true });
    }, 5000);
    return () => clearTimeout(timer);
  }, [user, loading, navigate]);

  return (
    <div className="min-h-dvh flex items-center justify-center">
      <LoadingPanel label="Finishing sign-in…" />
    </div>
  );
}
